module.exports = __webpack_public_path__ + "img/health.414eda5e.svg";